angular.module('picmonic-common').factory('MetaService', [
  '$timeout',
  '$rootScope',
  '$state',
  '$location',
  function ($timeout, $rootScope, $state, $location) {
    var defaults = {
      replacements: {},
      overrides: {},
      config: {
        'home': {
          match: '/',
          title: 'Picmonic\u00ae Picture Mnemonics - Medical School, Nursing School and more!',
          meta: {
            description:
              "The world's only research proven audiovisual mnemonic study aid. Ace the USMLE Step 1, Step 2 CK, COMLEX, NCLEX\u00ae, PANCE, NAPLEX and MCAT with Picmonic\u00ae - Better than flashcards!",
          },
          og: {
            title: 'Picmonic\u00ae Picture Mnemonics - Medical School, Nursing School and more!',
            image: 'https://www.picmonic.com/assets/img/home/meta-og-image.png',
            image_width: 250,
            image_height: 250,
            description: 'Ace USMLE, COMLEX, NCLEX\u00ae, PANCE, and MCAT with Picmonic',
          },
          twitter: {
            image: 'https://www.picmonic.com/assets/img/home/twitter-card-image2.png',
          },
        },
        'gb': {
          match: '/gb(.*)',
          og: {
            title: '%TITLE%',
            description: '%DESCRIPTION%',
            image: '%IMAGE%',
            image_width: 2400,
            image_height: 1260,
          },
          replacements: {},
        },
        'register': {
          match: '/register(.*)',
          title: 'Picmonic: Remember Everything, Forever. Sign up for Free.',
          og: {
            title: 'Sign up for Picmonic',
          },
          meta: {
            description:
              'Sign up for Free! Learn what you need to ace your medical classes and pass the USMLE, COMLEX, NCLEX, PANCE, MCAT, or NAPLEX. Get started now.',
          },
        },
        'testimonials': {
          match: '/testimonials',
          title: 'Real student reviews for Picmonic - Medical, Nursing, NP, PA, and more',
          meta: {
            description:
              'Real feedback from students who used Picmonic to succeed in classes, conquer boards, have more fun studying, and remember more in less time.',
          },
        },
        'home-app': {
          match: '/home',
          title: 'Picmonic Home Screen',
          meta: {
            description: 'Picmonic Home Screen',
            keywords: 'Picmonic Home Screen',
          },
          og: {
            title: 'Picmonic Home Screen',
            description: 'Manage your Picmonic account.',
          },
        },
        'quiz': {
          match: '/quiz/(.*)',
          title: '%QUIZ% Quiz',
          og: {
            title: 'Take the %QUIZ% Picmonic Quiz! Test yourself and see how well you know %QUIZ%!',
            description:
              'Do you know everything there is to know about %QUIZ%? Test your knowledge, then master our Picmonics to make sure you never forget the key facts!',
            image: 'https://cdn.picmonic.com/cloud_data/assets/img/quiz-share.png',
          },
          completed_og: {
            title: 'I got %ACCURACY% on the %QUIZ% Picmonic Quiz! Test yourself!',
            description:
              'Do you know everything there is to know about %QUIZ%? Test your knowledge, then master our Picmonics to make sure you never forget the key facts!',
            image: 'https://cdn.picmonic.com/cloud_data/assets/img/quiz-share.png',
          },
          twitter: {
            image: 'https://cdn.picmonic.com/cloud_data/assets/img/quiz-share.png',
          },
          replacements: {},
        },
        'pathways': {
          match: '/pathways(.*)',
          title: '%PATHWAY%',
          meta: {
            description: '%DESCRIPTION%',
          },
          og: {
            title: '%PATHWAY%',
            image: 'https://cdn.picmonic.com/cloud_data/production/assets/img/pathways/anatomy_large.png',
            description: '%DESCRIPTION%',
          },
          twitter: {
            image: 'https://cdn.picmonic.com/cloud_data/production/assets/img/pathways/anatomy_large.png',
          },
          replacements: {},
        },
        'qotd': {
          match: '/([^\\/]+)-question-of-the-day(.*)',
          title: 'Picmonic NCLEX Question of the Day%DATE%',
          meta: {
            description:
              'Free NCLEX practice questions sent to your inbox every day! Picmonic uses mnemonics to help you develop NCLEX mastery so you can pass the NCLEX exam the first time. Free question for %DATE2%',
            keywords:
              'cclex questions,nclex rn,free nclex questions,practice nclex questions,nursing question and answers,sample nclex questions,nursing question of the day,nclex,nclex practice,nursing study tips,nursing study material,nursing study guide,kaplan nursing,nursing mnemonics,nclex mastery',
            title: 'Picmonic NCLEX Question of the Day',
          },
          og: {
            title: "See if you can answer today's %QOTD% Question of the Day!",
            description:
              "Picmonic's Question of the Day is an easy, free way to test your knowledge for nursing school and the NCLEX\u00ae every day!",
            image: 'https://cdn.picmonic.com/cloud_data/assets/img/qotd-share.png',
          },
          completed_og: {
            title: "I chose the right answer for today's %QOTD% Question of the Day! See if you can get it right!",
            description:
              "Picmonic's Question of the Day is an easy, free way to test your knowledge for nursing school and the NCLEX\u00ae every day!",
            image: 'https://cdn.picmonic.com/cloud_data/assets/img/qotd-share.png',
          },
          twitter: {
            image: 'https://cdn.picmonic.com/cloud_data/assets/img/qotd-share.png',
          },
          replacements: {},
        },
        'admin': {
          match: '/adminv2(.*)',
          title: 'Picmonic Admin',
        },
        'playlists': {
          match: '/playlists/(.*)',
          title: '%TITLE%',
          meta: {
            description: '%DESCRIPTION%',
          },
          og: {
            title: '%TITLE%',
          },
          replacements: {},
        },
        'pricing': {
          match: '/pricing(.*)',
          title: 'Pricing - Picmonic for %MARKET%',
          og: {
            title: 'Purchase Picmonic for %MARKET%',
          },
          replacements: {},
        },
        'pricing-medicine': {
          match: '/pricing/medicine',
          title: 'Picmonic for Medicine: Master High Yield Information Faster.',
          meta: {
            description:
              'Picmonic is a proven, interactive, audiovisual learning platform to help you master complex medical information, quickly and efficiently.',
          },
        },
        'pricing-nursing': {
          match: '/pricing/nursing',
          title: 'Picmonic for Nursing: Pass the NCLEX-RN Guarantee.',
          meta: {
            description:
              'Picmonic simplifies Med-Surg, Pharmacology, and Pediatrics. Memorization made easy. Mobile apps to make it convenient. Pass the NCLEX guarantee.',
          },
        },
        'pricing-nursing-lpn': {
          match: '/pricing/nursing-lpn',
          title: 'Picmonic for Licensed Practical Nurse: Pass the NCLEX-PN Guarantee.',
          meta: {
            description:
              'Picmonic will help you get through nursing school. Memorization made easy. Mobile apps to make it convenient. Pass the NCLEX guarantee.',
          },
        },
        'pricing-nursing-np': {
          match: '/pricing/nursing-np',
          title: 'Picmonic for Nurse Practitioners: Success from Classroom to Exam Room',
          meta: {
            description:
              'Continue your nursing journey with confidence. Picmonic strengthens your knowledge in Pathology, Pharmacology, Epidemiology, and others. Show your mastery and succeed with licensure.',
          },
        },
        'pricing-physician-assistant': {
          match: '/pricing/physician-assistant',
          title: 'Picmonic for Physician Assistants: Pass the PANCE\u00ae or PANRE\u00ae Guarantee.',
          meta: {
            description:
              'Take Picmonic apps on the go so you can learn during your commute or workout. Save Time. Remember Everything. Pass the PANCE\u00ae or PANRE\u00ae.',
          },
        },
        'pricing-prehealth': {
          match: '/pricing/prehealth',
          title: 'Picmonic for Pre-Health: Prep for MCAT, PCAT, DAT, or Nursing school.',
          meta: {
            description:
              'Ace the MCAT, PCAT, DAT. Picmonic is proven to increase your pre medical or pre nursing school grades. Mobile apps for on the go.',
          },
        },
        'pricing-pharmacy': {
          match: '/pricing/pharmacy',
          title: 'Picmonic for Pharmacy: Memorize Drugs Easily.',
          meta: {
            description:
              'Picmonic is a proven mnemonic learning platform. Better than pharm flashcards. Remember pharmacology and complex medical information with ease.',
          },
        },
        'pricing-medical terminology': {
          match: '/pricing/medical-terminology',
          title: 'Picmonic for Medical Terminology: Master High Yield Information Faster.',
          meta: {
            description:
              'Picmonic is a proven, interactive, audiovisual learning platform to help you master complex medical terminology, quickly and efficiently.',
          },
        },
        'pricing-paramedic': {
          match: '/pricing/paramedic',
          title: 'Picmonic for Paramedic',
          meta: {
            description:
              'Picmonic is a proven, interactive, audiovisual learning platform to help you master complex medical information, quickly and efficiently.',
          },
        },
        'learn': {
          match: 'learn/(.*)',
          title: '%LEARN% - Learn on Picmonic',
          meta: {
            description:
              "Learn about %LEARN% faster and easier with Picmonic's unforgettable images and stories! Picmonic is research proven to increase your memory retention and test scores. Start learning today for free!",
          },
          og: {
            title: '%LEARN% - Picmonic for Medicine',
            image: '%IMAGE%',
            description:
              "Learn %LEARN% faster and easier with Picmonic's unforgettable images and stories! Picmonic is research proven to increase your memory retention and test scores. Start learning today for free!",
          },
          image: {
            image: '%IMAGE%',
          },
          replacements: {},
        },
        'mnemonics': {
          match: 'mnemonics/(.*)',
          title: '%LEARN% - Learn on Picmonic',
          meta: {
            description: '%OVERVIEW%',
          },
          og: {
            title: '%LEARN% - Picmonic for Medicine',
            image: 'https://cdn.picmonic.com/cloud_data/production/assets/img/pathways/Anatomy_small.png',
            description:
              "Learn %LEARN% faster and easier with Picmonic's unforgettable images and stories! Picmonic is research proven to increase your memory retention and test scores. Start learning today for free!",
          },
          image: {
            image: 'https://cdn.picmonic.com/cloud_data/production/assets/img/pathways/Anatomy_small.png',
          },
          replacements: {},
        },
        'schools': {
          match: 'schools/(.*)',
          title: '%SCHOOL% on Picmonic',
          og: {
            title: '%SCHOOL% on Picmonic',
          },
          replacements: {},
        },
        'my-picmonics': {
          match: '/my-picmonics',
          title: 'My Picmonics',
        },
        'my-notes': {
          match: '/my-notes',
          title: 'My Notes',
        },
        'referrals': {
          match: '/referrals',
          title: 'My Referrals',
        },
        'resources-medicine': {
          match: '/resources/medicine',
          title: 'Medical School Resources',
          og: {
            title: 'Medical School Resources',
          },
          meta: {
            description:
              'Use this comprehensive collection of resources alongside your classes and Qbanks. Review and retain everything you need to know for med school.',
          },
        },
        'resources-nursing-rn': {
          match: '/resources/nursing',
          title: 'Nursing RN School Resource Portal',
          og: {
            title: 'Nursing RN School Resource Portal',
          },
          meta: {
            description:
              'Use this comprehensive collection of resources alongside your current resources and classes and Qbanks. Review and retain everything you need to know for nursing RN school. ',
          },
        },
        'resources-nursing-lpn': {
          match: '/resources/nursing-lpn',
          title: 'Nursing LPN School Resource Portal',
          og: {
            title: 'Nursing LPN School Resource Portal',
          },
          meta: {
            description:
              'Use this comprehensive collection of resources alongside your current resources and classes and Qbanks. Review and retain everything you need to know for nursing LPN school. ',
          },
        },
        'resources-nursing-np': {
          match: '/resources/nursing-np',
          title: 'Nurse Practitioner School Success Portal',
          og: {
            title: 'Nurse Practitioner School Success Portal',
          },
          meta: {
            description:
              'Use this comprehensive collection of resources alongside your classes & Qbanks. Review everything you need to know for NP school and your certification exams.',
          },
        },
        'resources-paramedic': {
          match: '/resources/paramedic',
          title: 'Paramedic Resource Portal',
          og: {
            title: 'Paramedic Resource Portal',
          },
          meta: {
            description:
              'Review everything you need to know for both classes and certification exams like the National Registry, State Licensure, Local Credentialing, and more. ',
          },
        },
        'resources-pharmacy': {
          match: '/resources/pharmacy',
          title: 'Pharmacy Resource Portal',
          og: {
            title: 'Pharmacy Resource Portal',
          },
          meta: {
            description:
              'Pharmacy school resources to use alongside your classes and Qbanks, so you can successfully retain everything you need to know for pharm school and the NAPLEX. ',
          },
        },
        'resources-physician-assistant': {
          match: '/resources/physician-assistant',
          title: 'Physician Assistant Resource Portal',
          og: {
            title: 'Physician Assistant Resource Portal',
          },
          meta: {
            description:
              'Use this collection of Physician Assistant study resources alongside your classes and Qbanks, so you can successfully retain everything you need to know for PA school. ',
          },
        },
        'resources-prehealth': {
          match: '/resources/prehealth',
          title: 'Pre-Health Resource Portal',
          og: {
            title: 'Pre-Health Resource Portal',
          },
          meta: {
            description:
              'Use this collection of Pre-Health study resources so you can successfully retain everything you need to know for both classes and the MCAT.  ',
          },
        },
        'resources-nclex-pn-resource-portal': {
          match: '/resources/nclex-pn-resource-portal',
          title: 'NCLEX-PN\u00ae Resource Portal',
          og: {
            title: 'NCLEX-PN\u00ae Resource Portal',
          },
          meta: {
            description:
              "Use this collection of NCLEX-PN\u00ae study resources alongside your classes and Qbanks, so you'll retain everything you need to know for and pass the NCLEX\u00ae.",
          },
        },
        'resources-nclex-rn-resource-portal': {
          match: '/resources/nclex-rn-resource-portal',
          title: 'NCLEX-RN\u00ae Resource Portal',
          og: {
            title: 'NCLEX-RN\u00ae Resource Portal',
          },
          meta: {
            description:
              "Use this collection of NCLEX-RN\u00ae study resources alongside your classes and Qbanks, so you'll retain everything you need to know for and pass the NCLEX\u00ae.",
          },
        },
        'resources-pance-resource-portal': {
          match: '/resources/pance-resource-portal',
          title: 'PANCE Resource Portal',
          og: {
            title: 'PANCE Resource Portal',
          },
          meta: {
            description:
              "Use this collection of PANCE study resources alongside your classes and Qbanks, so you'll retain everything you need to know for PA school and pass the PANCE\u00ae or PANRE\u00ae. ",
          },
        },
        'resources-usmle-step-1-and-comlex-resource-portal': {
          match: '/resources/usmle-step-1-and-comlex-resource-portal',
          title: 'Step 1 and COMLEX Resource Portal',
          og: {
            title: 'Step 1 and COMLEX Resource Portal',
          },
          meta: {
            description:
              'Use this collection of resources alongside your classes and Step 1 Qbanks, so can successfully review and retain everything you need to know for USMLE & COMLEX. ',
          },
        },
        'login': {
          match: '/login',
          og: {
            title: 'Log in to Picmonic',
          },
          title: 'Log in to Picmonic',
        },
        'educators': {
          match: '/educators',
          title: 'Picmonic for Educators',
          og: {
            title: 'Picmonic for Educators',
            description:
              'Help your students excel with Picmonic, the visual learning platform proven to improve knowledge retention and exam performance.',
          },
          meta: {
            description:
              'Help your students excel with Picmonic, the visual learning platform proven to improve knowledge retention and exam performance.',
          },
        },
        'why-picmonic': {
          match: '/pillars/why-picmonic',
          title: 'Why Students Use Picmonic to Improve Memory Retention for School Exams',
          og: {
            title: 'Why Students Use Picmonic to Improve Memory Retention for School Exams',
            description:
              'Medical, nursing and PA students use several tools to learn, review and practice test questions in school. But, only Picmonic has comprehensive test prep material and recall quizzes to work alongside your coursebooks, question banks and tools to help you increase retention and boost test scores!',
          },
          meta: {
            description:
              'Medical, nursing and PA students use several tools to learn, review and practice test questions in school. But, only Picmonic has comprehensive test prep material and recall quizzes to work alongside your coursebooks, question banks and tools to help you increase retention and boost test scores!',
          },
        },
        'up-to-date': {
          match: '/pillars/up-to-date',
          title: 'Picmonic is the most up to date mnemonic tool for healthcare students.',
          og: {
            title: 'Picmonic is the most up to date mnemonic tool for healthcare students.',
            description: '',
          },
          meta: {
            description: '',
          },
        },
        'research-proven': {
          match: '/pillars/research-proven',
          title: 'Picmonic is research proven to improve memory retention.',
          og: {
            title: 'Picmonic is research proven to improve memory retention.',
            description:
              'Research proven to improve memory retention. Picmonic visual mnemonics really work. Trust in science. Trust in Picmonic to remember more in less time',
          },
          meta: {
            description:
              'Research proven to improve memory retention. Picmonic visual mnemonics really work. Trust in science. Trust in Picmonic to remember more in less time',
          },
        },
        'related-facts': {
          match: '/pillars/related-facts',
          title: 'Picmonic characters are consistent to link relevant topics.',
          og: {
            title: 'Picmonic characters are consistent to link relevant topics.',
            description:
              'Picmonic characters stay consistent to link relevant topics in your memory, the only visual mnemonic study tool enabling you to remember what matters most.',
          },
          meta: {
            description:
              'Picmonic characters stay consistent to link relevant topics in your memory, the only visual mnemonic study tool enabling you to remember what matters most.',
          },
        },
        'on-the-go': {
          match: '/pillars/on-the-go',
          title: 'Picmonic on the go - mobile quizzing with offline mode - print and go.',
          og: {
            title: 'Picmonic on the go - mobile quizzing with offline mode - print and go.',
            description:
              'Picmonic on the go - mobile quizzing with offline mode - ios and android - print and go - make any moment a study moment to improve memory retention, forever',
          },
          meta: {
            description:
              'Picmonic on the go - mobile quizzing with offline mode - ios and android - print and go - make any moment a study moment to improve memory retention, forever',
          },
        },
        'forgetting-curve': {
          match: '/pillars/forgetting-curve',
          title: 'Picmonic is proven to help you remember more in less time',
          og: {
            title: 'Picmonic is proven to help you remember more in less time',
            description:
              'Improving Memory Retention throughout School - Picmonic is proven to conquer the forgetting curve - mnemonic study tools to remember more in less time',
          },
          meta: {
            description:
              'Improving Memory Retention throughout School - Picmonic is proven to conquer the forgetting curve - mnemonic study tools to remember more in less time',
          },
        },
        'efficient-effective': {
          match: '/pillars/efficient-effective',
          title: 'Picmonic picture mnemonics are concise mnemonic videos. ',
          og: {
            title: 'Picmonic picture mnemonics are concise mnemonic videos. ',
            description:
              'The Fastest Way to Remember Forever - Picmonic picture mnemonics are concise mnemonic videos proven to work better than any sketchy pharm flashcards',
          },
          meta: {
            description:
              'The Fastest Way to Remember Forever - Picmonic picture mnemonics are concise mnemonic videos proven to work better than any sketchy pharm flashcards',
          },
        },
        'customize-create': {
          match: '/pillars/customize-create',
          title: 'Create mnemonic videos on your own - interact, engage, remember.',
          og: {
            title: 'Create mnemonic videos on your own - interact, engage, remember.',
            description:
              'Customize our Picmonics\u00ae or create picture mnemonic videos on your own - interact engage and remember forever',
          },
          meta: {
            description:
              'Customize our Picmonics\u00ae or create picture mnemonic videos on your own - interact engage and remember forever',
          },
        },
        'comprehensive-coverage': {
          match: '/pillars/comprehensive-coverage',
          title: 'High yield topics you need to ace the USMLE, NCLEX, PANCE, and more',
          og: {
            title: 'High yield topics you need to ace the USMLE, NCLEX, PANCE, and more',
            description: 'Improving Memory Retention - USMLE, NCLEX, PANCE, AANP and more, your first time',
          },
          meta: {
            description: 'Improving Memory Retention - USMLE, NCLEX, PANCE, AANP and more, your first time',
          },
        },
        'webinars': {
          match: '/events/webinars',
          title: 'Med & Nursing Webinars | Tips & Advice for Medical School, Nursing School and more!',
          meta: {
            description:
              'Learn the latest and greatest med and nursing school tips from healthcare experts to help you ace the USLME Step 1, Step 2 CK, COMLEX, NCLEX and more. View now!',
          },
        },
      },
    };

    var MetaService = {
      setConfig: function (config) {
        this.config = config;
      },
      replace: function (tag, value, doNotRun) {
        this.replacements[tag] = value;
        if (!doNotRun) {
          MetaService.run();
        }
      },
      getRoute: function (name) {
        return this.config.hasOwnProperty(name) ? angular.copy(this.config[name]) : {};
      },
      getReplacements: function () {
        return this.replacements;
      },
      run: function () {
        var url = $location.url();

        // Get default meta
        var meta = MetaService.getRoute('home');

        // Get route meta
        for (var route_name in this.config) {
          if (this.config.hasOwnProperty(route_name) && route_name.length) {
            var route = this.config[route_name];
            var meta_regex = new RegExp(route.match.replace(/\//g, '\\/'), 'i');
            if (url.match(meta_regex)) {
              // Assign route meta
              meta.meta.description = false;
              meta = angular.merge(meta, route);
            }
          }
        }

        // Combine with state meta
        var state_meta = $state.$current.resolve ? MetaService.prepMetaVariable($state.$current.resolve.$meta) : {};
        var meta_replacements = MetaService.getReplacements();
        meta = angular.merge(meta, state_meta);
        meta = angular.merge(meta, this.overrides);

        // Replace the MetaService replacements
        if (meta_replacements) {
          meta = MetaService.parseMetaVar(meta, meta_replacements);
        }

        // If the state meta provided a list of replacements, replace them
        if (meta.replacements) {
          meta = MetaService.parseMetaVar(meta, meta.replacements);
        }

        meta = MetaService.removeUnresolvedReplacements(meta);

        $timeout(function () {
          $rootScope.$meta = meta;
        });
      },
      parseMetaVar: function (variable, replacements) {
        var cloned = angular.copy(variable);
        if (typeof cloned == 'object') {
          for (var x in cloned) {
            if (x != 'replacements' && x != 'run' && cloned.hasOwnProperty(x)) {
              cloned[x] = MetaService.parseMetaVar(cloned[x], replacements);
            }
          }
        } else if (typeof cloned == 'string') {
          for (var y in replacements) {
            if (replacements.hasOwnProperty(y)) {
              cloned = cloned.replace(new RegExp(y, 'ig'), replacements[y]);
            }
          }
        }
        return cloned;
      },
      removeUnresolvedReplacements: function (meta) {
        var cloned = angular.copy(meta);
        if (typeof cloned == 'object') {
          for (var x in cloned) {
            if (x != 'replacements' && cloned.hasOwnProperty(x)) {
              cloned[x] = MetaService.removeUnresolvedReplacements(cloned[x]);
            }
          }
        } else if (typeof cloned == 'string') {
          cloned = cloned.replace(new RegExp('%([^%]+)%', 'g'), '...');
        }
        return cloned;
      },
      prepMetaVariable: function (meta) {
        return angular.isFunction(meta) ? meta() : meta;
      },
      reset: function () {
        angular.merge(this, defaults);
        this.replacements = {};
        this.overrides = {};
      },
      override: function (param, value) {
        if (typeof this.overrides[param] == 'object' && typeof value == 'object') {
          Object.assign(this.overrides[param], value);
        } else {
          this.overrides[param] = value;
        }
      },
    };

    MetaService.reset();
    return MetaService;
  },
]);
